import AccountVerify from "./AccountVerify";

export default AccountVerify;
